import { useParams } from 'react-router-dom';
import { useGetPatientQuery } from '~/store/services/patients';
import PatientClinicalProfileTab from '~/components/maud/patients/profile/tabs/PatientClinicalProfileTab';
import { useGetAssessmentsListQuery } from '~/store/services/assessments';
import { getPreferredFullName } from '~/lib/util/patient.util';

const ClinicalProfilePage = () => {
  const { patientId } = useParams<{ patientId: string }>();
  const { data: patient } = useGetPatientQuery({ patientId });
  const { data: assessmentsList } = useGetAssessmentsListQuery(
    { patientId },
    { skip: !patientId },
  );

  if (!patient) return null;

  const patientPreferredFullName = getPreferredFullName(
    patient.chosenName,
    patient.firstName,
    patient.lastName,
    false,
  );

  return (
    <PatientClinicalProfileTab
      assessmentList={assessmentsList?.assessments ?? []}
      patient={patient}
      patientId={patientId}
      patientPreferredFullName={patientPreferredFullName}
    />
  );
};

export default ClinicalProfilePage;
